{
  "noToken": "Dieser Link ist unvollständig. Öffnen Sie den Link aus der E-Mail erneut.",
  "successActive": "Ihre E-Mail-Adresse ist bestätigt. Sie können sich jetzt anmelden.",
  "successPendingApproval": "Ihre E-Mail-Adresse ist bestätigt. Nun wird Ihre Registrierung geprüft; Sie erhalten eine E-Mail, sobald Ihr Konto bereit ist.",
  "title": "E-Mail-Adresse bestätigen",
  "toApp": "Weiter zur Anmeldung",
  "wait": "Wird bestätigt …"
}
